module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_house_tvb-c4970b5c2f3e27f8579541a1d90185e4.jpg";